import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row } from 'reactstrap';
import { useRouter } from "next/router";
import useSolutions from '@/hooks/useSolutions';
import styles from './styles.module.scss';

export const Solutions = ({
    className,
    title,
    titleColour,
}) => {

    const locale = useRouter().asPath.startsWith("/us/") ? "/us/" : "/";

    const items = useSolutions({locale});

    if (!items || !items.length > 0) {
        return null;
    }

    return (
        <section className={`${styles.root} ${className}`}>
            <Container className="py-4 py-md-5">
                {title &&
                    <div className="text-center mb-4">
                        <h2 className={`text-${titleColour?.variant} m-0`} style={{color: titleColour?.custom}}>{title}</h2>
                    </div>
                }
                <Row className="d-flex flex-wrap m-0">
                    {items?.map((item, index) => (
                        <a href={`${locale}employers/${item.url_slug}`} className="card" key={index}>
                            <div>
                                <figure className="m-0">
                                    <SourceFlowImage
                                        src={item?.icon ? item.icon : "/site-assets/placeholders/img-placeholder.jpg"}
                                        size="250x"
                                        alt={item?.title}
                                        className="card-img mb-4"
                                        width="100%"
                                        height="100%"
                                    />
                                </figure>
                                <span>
                                    {item?.title}
                                </span>
                            </div>
                        </a>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default Solutions;
